var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorDash04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9728 18.0388C23.4184 18.58 23.1016 19.3588 23.1808 20.1904C23.2996 21.616 24.6064 22.6588 26.032 22.6588H28.54V24.2296C28.54 26.962 26.3092 29.1928 23.5768 29.1928H8.42316C5.69076 29.1928 3.45996 26.962 3.45996 24.2296V15.346C3.45996 12.6136 5.69076 10.3828 8.42316 10.3828H23.5768C26.3092 10.3828 28.54 12.6136 28.54 15.346V17.2468H25.8736C25.1344 17.2468 24.4612 17.5372 23.9728 18.0388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.762 5.36844V10.3844H8.42316C5.69076 10.3844 3.45996 12.6152 3.45996 15.3476V10.5033C3.45996 8.93246 4.42356 7.5332 5.88876 6.9788L16.3696 3.0188C18.0064 2.4116 19.762 3.61284 19.762 5.36844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9394 18.5963V21.3156C29.9394 22.0416 29.3586 22.6356 28.6194 22.662H26.0322C24.6066 22.662 23.2998 21.6192 23.181 20.1936C23.1018 19.362 23.4186 18.5832 23.973 18.042C24.4614 17.5404 25.1346 17.25 25.8738 17.25H28.6194C29.3586 17.2764 29.9394 17.8703 29.9394 18.5963Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6402 16.9878H9.40016C8.85896 16.9878 8.41016 16.539 8.41016 15.9978C8.41016 15.4566 8.85896 15.0078 9.40016 15.0078H18.6402C19.1814 15.0078 19.6302 15.4566 19.6302 15.9978C19.6302 16.539 19.1814 16.9878 18.6402 16.9878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDash04);
export default __webpack_public_path__ + "static/media/doctor-dash-04.af2d871b432724e7c07f5ecbc7e7c9a7.svg";
export { ForwardRef as ReactComponent };